const Rating = {
  CreditRatingNoCompanySelectedText: "Rating.CreditRatingNoCompanySelectedText",
  HowHighRating: "Rating.HowHighRating",
  NoRatingFoundShort: "Rating.NoRatingFoundShort",
  NoRatingFound_Supplier: "Rating.NoRatingFound_Supplier",
  Great_Supplier: "Rating.Great_Supplier",
  Good_Supplier: "Rating.Good_Supplier",
  Ok_Supplier: "Rating.Ok_Supplier",
  NotSure_Supplier: "Rating.NotSure_Supplier",
  Bad_Supplier: "Rating.Bad_Supplier",
  None_Supplier: "Rating.None_Supplier",
  NoRatingFound_Customer: "Rating.NoRatingFound_Customer",
  Great_Customer: "Rating.Great_Customer",
  Good_Customer: "Rating.Good_Customer",
  Ok_Customer: "Rating.Ok_Customer",
  NotSure_Customer: "Rating.NotSure_Customer",
  Bad_Customer: "Rating.Bad_Customer",
  None_Customer: "Rating.None_Customer",
  }
export default Rating;